import { render } from "./bigIntValue.vue?vue&type=template&id=2848cdda&ts=true"
import script from "./bigIntValue.vue?vue&type=script&lang=ts"
export * from "./bigIntValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__